import { render, staticRenderFns } from "./CheckYesNo.vue?vue&type=template&id=cfad0048&scoped=true"
import script from "./CheckYesNo.vue?vue&type=script&lang=js"
export * from "./CheckYesNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfad0048",
  null
  
)

export default component.exports